import Cookie from 'js-cookie'
import { auth } from '../../core/src/apis/auth'
import { IAM, MessageResponse } from '@rhitics/core/types'

export class Auth {
  static tokenKey = 'accessToken'

  public static guest() {
    return !Auth.check()
  }

  public static check() {
    return Auth.token() !== null
  }

  public static token() {
    return Cookie.get(Auth.tokenKey) || null
  }

  public static async register(options: { name: string; email: string; password: string }) {
    const response = await auth.register(options)
    Auth.setToken(response.data.access_token)
    return response
  }

  public static async login(email?: string, password?: string) {
    const env = process.env
    const account = { email, password }
    if (env.NODE_ENV !== 'production' && !email && !password) {
      account.email = env.VUE_APP_USER_EMAIL
      account.password = env.VUE_APP_USER_PASSWORD
    }
    const response = await auth.login(account.email || '', account.password || '')
    Auth.setToken(response.data.access_token)
    return response
  }

  public static async logout() {
    const response = (await auth.logout()) as MessageResponse
    Auth.removeToken()
    return response
  }

  public static forget() {
    Auth.removeToken()
  }

  public static async user(token?: string) {
    const user = (await auth.me(token)).data as IAM.UserAggregate
    return user
  }

  public static generateBeam() {
    return auth.beamAuth()
  }

  // NOTICE: the availableDays should be the same as the setting in backend
  protected static setToken(token: string, availableDays = 7) {
    Cookie.set(Auth.tokenKey, token, {
      domain: '.' + location.hostname,
      expires: availableDays,
      sameSite: 'strict'
    })
  }

  protected static removeToken() {
    Cookie.remove(Auth.tokenKey, { domain: '.' + location.hostname })
  }
}
